import { useQuery } from '@tanstack/react-query';
import type {
  CareSearchPatientsRequestT,
  CareSearchPatientsResponseT,
} from '@lotushealth/lotushealth_js_sdk/schemas';

import { fetchCareSearchPatients } from '../api/searchPatients.js';
import { carePatientsKeys } from './keys.js';

const DEFAULT_SEARCH_REQUEST: CareSearchPatientsRequestT = { query: '', limit: 1000 };

export function careSearchPatientsQueryDefinition(request: CareSearchPatientsRequestT) {
  return {
    queryKey: carePatientsKeys.search(request),
    queryFn: ({ signal }: { signal?: AbortSignal }): Promise<CareSearchPatientsResponseT> =>
      fetchCareSearchPatients(request, signal),
    meta: {
      toast: {
        title: 'Could not load patients',
        description: 'Patient search could not be fetched.',
      },
    },
  } as const;
}

export function useCareSearchPatientsQuery(request: CareSearchPatientsRequestT | undefined) {
  const resolvedRequest = request ?? DEFAULT_SEARCH_REQUEST;
  return useQuery(careSearchPatientsQueryDefinition(resolvedRequest));
}
